const LeaveReasonConstant = {
  REPAIR_TOO_EXPENSIVE: "REPAIR_TOO_EXPENSIVE",
  REPAIR_TOO_EXPENSIVE_AND_BUY_OTHER: "REPAIR_TOO_EXPENSIVE_AND_BUY_OTHER",
  REPAIR_TOO_EXPENSIVE_AND_BUY_SAME: "REPAIR_TOO_EXPENSIVE_AND_BUY_SAME",
  NO_PACKAGE: "NO_PACKAGE",
  BUY_OTHER: "BUY_OTHER",
  OTHER: "OTHER",

  // Can't remove this, because some old repair file use this value. But not use this for new one.
  NON_REPAIRABLE: "NON_REPAIRABLE", // Deprecated
  GUARANTEE_TOO_RIGID: "GUARANTEE_TOO_RIGID", // Deprecated
  NOT_GUARANTEED: "NOT_GUARANTEED" // Deprecated
}

export default LeaveReasonConstant;
